import * as Core from './core';
import * as Util from '../util';

const prefix = '/proposal';
// const postFile = (path: string, params: object) => Core.uploadFile('POST', prefix + path, params);
// const putFile = (path: string, params: object) => Core.uploadFile('PUT', prefix + path, params);
// const patchFile = (path: string, params: object) => Core.uploadFile('PATCH', prefix + path, params);

const post = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('POST', prefix + path, params, ignore403);
const patch = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PATCH', prefix + path, params, ignore403);
const put = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PUT', prefix + path, params, ignore403);

const get = (path: string, params?: object, ignore403?: boolean) => Core.get(prefix + path, params, ignore403);
const del = (path: string, params?: object, ignore403?: boolean) => Core.del(prefix + path, params, ignore403);

// const postFileJson = async (path: string, params: object) => (await postFile(path, params)).json();
// const putFileJson = async (path: string, params: object) => (await putFile(path, params)).json();
// const patchFileJson = async (path: string, params: object) => (await patchFile(path, params)).json();

// const postJson = async (path: string, params?: object, ignore403?: boolean) => (await post(path, params, ignore403)).json();
// const patchJson = async (path: string, params?: object, ignore403?: boolean) => (await patch(path, params, ignore403)).json();
// const putJson = async (path: string, params?: object, ignore403?: boolean) => (await put(path, params, ignore403)).json();

const getJson = async (path: string, params?: object, ignore403?: boolean) => (await get(path, params, ignore403)).json();
// const delJson = async (path: string, params?: object, ignore403?: boolean) => (await del(path, params, ignore403)).json();

const saveKeys = [
    'admin',
    'client',
    'adminSecondary',
    'timeRequired',
    'engagementType',
    'engagementTypeDetails',
    'proposalTitle',
    'startDate',
    'endDate',
    'startDateTBC',
    'endDateTBC',
    'description',
    'consultants',
    'consultantMeta',
    'dealId',
];

export const getProposalConsultant = (proposalId: string, consultantId: string, body?: object) => getJson(`/${proposalId}/profile/${consultantId}`, body);
export const getProposal = (_id?: string) => getJson('', Core.filterVals({_id}));
// TODO: deduplicate?
export const getProposal2 = async (_id: string) => {
    let proposal = await getJson(`/${_id}`);
    proposal = Util.update(proposal, 'startDate', Util.dateOption);
    proposal = Util.update(proposal, 'endDate', Util.dateOption);
    return proposal;
};
export const getProposalReadOnly = async (_id: string) => {
    let proposal = await getJson(`/${_id}/read-only`);
    proposal = Util.update(proposal, 'startDate', Util.dateOption);
    proposal = Util.update(proposal, 'endDate', Util.dateOption);
    return proposal;
};
export const putProposal = (_id: string, proposal: object) => (
    put('/' + _id, {proposal: JSON.stringify(Util.selectKeys(proposal, saveKeys))})
);
export const parkProposal = (_id: string) => patch(`/${_id}/park`);
export const unparkProposal = (_id: string) => patch(`/${_id}/unpark`);
export const delProposal = (_id: string) => del('/' + _id);
export const send = (_id: string, to: string, cc: string, subject: string, body: string) => patch(`/${_id}/send`, {body, subject, emails: to, cc});
export const postProposal = (proposal: object) => post('', {proposal: JSON.stringify(proposal)});



// WEBPACK FOOTER //
// ./src/client/Proposal.tsx